import { useWatch } from 'react-hook-form';
import Avatar from '../Custom/Avatar';
import type { EntityListValues } from './EntityList.types';

function EntityListAvatar({ name, index }: { name: string; index: number }) {
  const { avatarId, localAvatarUrl, color, title } = useWatch<
    EntityListValues,
    `${string}.${number}`
  >({
    name: `${name}.${index}`,
  });

  return (
    <Avatar
      localUrl={localAvatarUrl!}
      id={avatarId!}
      color={color}
      name={title!}
    />
  );
}

export default EntityListAvatar;
